import { ActionButton, Spinner } from '@fluentui/react';
import { useState } from 'react';

import { popup } from '../../addons/Popup';
import { getAsync } from '../../utils/api';
import { addIcon } from '../../utils/icons';
import ContentBox from '../ContentBox';
import FormSearch from '../Forms/Search/FormSearch';

const FormActions = ({ formId }: { formId: string }) => {
  const [loading, setLoading] = useState<boolean>();
  const [uses, setUses] = useState(0);

  const toggle = async () => {
    setLoading(true);

    getAsync("/delivery-paper/add-form?id=" + formId)
      .then(() => {
        setUses(uses + 1);
        setLoading(false);
      })
      .catch(() => popup("Hata: Form Eklenemedi"));
  };

  if (loading) {
    return <Spinner />;
  } else {
    return (
      <ActionButton
        text={`Ekle ${uses > 0 ? `(${uses})` : ""}`}
        iconProps={addIcon}
        onClick={toggle}
      />
    );
  }
};

export default () => {
  const actions = (formId: string) => <FormActions formId={formId} />;

  return (
    <div style={{ width: "35vw", paddingTop: "8px" }}>
      <ContentBox>
        <div style={{ height: "calc(95vh - 105px)", overflow: "auto" }}>
          <div style={{ marginRight: "4px" }}>
            <FormSearch compact useLatestOnIdle actions={actions} />
          </div>
        </div>
      </ContentBox>
    </div>
  );
};
